import React, { FC, useEffect, useState } from "react";
import {
  Row,
  Col,
  Upload,
  Table,
  message,
  Progress,
  Button,
  Space,
  Modal,
} from "antd";
import type { ColumnsType } from "antd/es/table";
import { apost } from "@root/service/axios";
import { RcFile } from "antd/lib/upload";
import { UploadRequestOption } from "rc-upload/lib/interface";
import { uploadVideo, saveVideo } from "@root/common/service";
import axios, { AxiosRequestConfig } from "axios";

interface DataType {
  key: string;
  name: string;
  age: number;
  address: string;
  tags: string[];
}

interface ICreateUploadProp {
  chunkUrl: string;
  metaUrl: string;
  serviceType: string;
  userId: string;
  videoId: string;
}

interface IProps {
  isUploadVideoVisible: boolean;
  treeSelect: string;
  setIsUploadVideoVisible: React.Dispatch<React.SetStateAction<boolean>>;
  getList: (page?: number, params?: object) => Promise<void>;
}

// 计算文件大小
const calcFileSize = (size: number) => {
  const valueSymbols = [
    {
      size: Math.pow(1024, 3),
      title: "GB",
    },
    {
      size: Math.pow(1024, 2),
      title: "MB",
    },
    {
      size: Math.pow(1024, 1),
      title: "KB",
    },
    {
      size: 0,
      title: "B",
    },
  ];

  for (let i = 0; i < valueSymbols.length; i++) {
    if (size > valueSymbols[i].size) {
      return (
        Math.floor((size / valueSymbols[i].size) * 100) / 100 +
        valueSymbols[i].title
      );
    }
  }
};

// 计算进度
const calcProgress = (num: number, size: number) => {
  return Math.floor((num / size) * 10000) / 100;
};

// 计算所需时间
const calcUpdateTime = (len: number, speed: number) => {
  len = len < 0 ? 0 : len;
  speed = speed < 1 ? 1 : speed;

  let time = Math.floor(len / speed / 1000);
  let hour: string | number = 0;
  let minute: string | number = 0;
  let second: string | number = 0;

  minute = Math.floor((time - hour * 3600) / 60);
  minute = minute < 10 ? "0" + minute : minute;
  second = time % 60 > 0 ? time % 60 : 1;
  second = second < 10 ? "0" + second : second;
  hour = Math.floor(time / 3600);
  hour = hour < 10 ? "0" + hour : hour;

  return hour + ":" + minute + ":" + second;
};

const packageFormData = (params: any) => {
  const data = new FormData();
  Object.keys(params).forEach((key) => {
    data.append(key, params[key]);
  });

  return data;
};

let FILELIST: any = {};
export const UploadVideo: FC<IProps> = (props) => {
  const [videoList, setVideoList] = useState<any>([]);
  const [uploadLength, setUpLoadLength] = useState(0);

  const columns: ColumnsType<DataType> = [
    {
      title: "文件名",
      dataIndex: "name",
      key: "name",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "格式",
      dataIndex: "format",
      key: "format",
    },
    {
      title: "大小",
      dataIndex: "size",
      key: "size",
    },
    {
      title: "状态",
      dataIndex: "state",
      width: 280,
      render(state: number, data: any) {
        switch (state) {
          case 0:
            return (
              <div>
                {data.suspend === 2 ? (
                  <>
                    <p>已取消</p>
                  </>
                ) : (
                  <>
                    <Progress percent={data.progress} size="small" />
                    <p>
                      {data.bitrate} | {data.timeremain || ""}
                    </p>
                  </>
                )}
              </div>
            );

          case 1:
            return (
              <div>
                <Progress percent={100} size="small" />
                <p>上传成功</p>
              </div>
            );

          default:
            return <div>上传失败</div>;
        }
      },
    },
    {
      title: "操作",
      dataIndex: "key",
      render(_: number, data: any) {
        if (data.state === 0 && data.suspend !== 2) {
          return (
            <Space>
              {data.suspend === 1 ? (
                <Button
                  onClick={() => {
                    onContinueClickHandle(data);
                  }}
                >
                  继续
                </Button>
              ) : (
                <Button
                  onClick={() => {
                    onSuspendClickHandle(data);
                  }}
                >
                  暂停
                </Button>
              )}
              <Button
                danger
                ghost
                type="primary"
                onClick={() => {
                  onCancelClickHandle(data);
                }}
              >
                取消
              </Button>
            </Space>
          );
        }
      },
    },
  ];

  const data: DataType[] = [
    {
      key: "1",
      name: "John Brown",
      age: 32,
      address: "New York No. 1 Lake Park",
      tags: ["nice", "developer"],
    },
    {
      key: "2",
      name: "Jim Green",
      age: 42,
      address: "London No. 1 Lake Park",
      tags: ["loser"],
    },
    {
      key: "3",
      name: "Joe Black",
      age: 32,
      address: "Sidney No. 1 Lake Park",
      tags: ["cool", "teacher"],
    },
  ];

  const onSuspendClickHandle = (params: any) => {
    params.cancel("暂停上传视频");
    setTimeout(() => {
      setVideoList((prevCont: any) => {
        const newCont = [...prevCont];
        newCont[params.key].suspend = 1;
        newCont[params.key].bitrate = "0kbps";
        newCont[params.key].timeremain = "00:00:00";
        return newCont;
      });
    }, 110);
  };

  const onContinueClickHandle = (params: any) => {
    const file = FILELIST[params.fileId];

    getCCMetaInfo(params.create.metaUrl, {
      ccvid: params.create.videoId,
      uid: params.create.userId,
      filename: encodeURI(file.name),
      filesize: file.size,
      servicetype: params.create.serviceType,
    }).then((res: any) => {
      new Promise((resolve) => {
        setVideoList((prevCount: any) => {
          const newCount = [...prevCount];
          newCount[params.key].suspend = 0;

          resolve({
            file: file,
            createUpload: params.create,
            index: params.key,
            meta: res,
          });

          return [...newCount];
        });
      }).then((res) => {
        postVideoChunk(res);
      });
    });
  };

  const onCancelClickHandle = (params: any) => {
    Modal.confirm({
      title: "取消确认",
      content: "取消之后当前上传进度无法恢复，您确定取消吗？",
      okText: "确认",
      cancelText: "取消",
      onOk() {
        return new Promise((resolve, reject) => {
          delete FILELIST[params.fileId];

          if (!params.suspend) params.cancel("暂停上传视频");

          setVideoList((prevCount: any) => {
            const newCount = [...prevCount];
            newCount[params.key].suspend = 2;
            newCount[params.key].bitrate = "0kbps";
            newCount[params.key].timeremain = "00:00:00";
            return newCount;
          });
          resolve("取消上传");
        }).catch(() => console.log("Oops errors!"));
      },
    });
  };

  const getCCMetaInfo = (url: string, params: any) => {
    return new Promise((resolve, rejects) => {
      axios.get(url, { params: params }).then((res: any) => {
        if (res.data.result === 0) {
          resolve(res.data);
        }
      });
    });
  };

  const postVideoChunk = async (params: any) => {
    const { file, createUpload, index, meta } = params;

    // 每块文件大小 & 文件分块数量
    const SECTIONSIZE = 4 * 1024 * 1024 - 1;
    const SECTIONTOTAL = Math.ceil(file.size / SECTIONSIZE);

    // 文件起始位置 &  文件结束位置
    let sSize = meta.received;
    let eSize =
      sSize + SECTIONSIZE < file.size ? sSize + SECTIONSIZE : file.size - 1;

    //
    let oldTime = new Date().valueOf();
    let oldLoadSize = sSize;

    let result = 0;

    while (result === 0) {
      // 定义ajax请求
      // 路径 = 创建时返回的chunkurl + videoid
      // 自定义请求头：Content-Range Content-Disposition
      const axiosOptions: AxiosRequestConfig = {
        url: createUpload.chunkUrl + "?ccvid=" + createUpload.videoId,
        method: "post",
        headers: {
          "Content-Range": "bytes " + sSize + "-" + eSize + "/" + file.size,
          "Content-Disposition":
            'attachment; filename="' + encodeURI(file.name),
        },
        data: packageFormData({ file: file.slice(sSize, eSize + 1) }),
      };

      let timer: NodeJS.Timeout | null = null;
      axiosOptions.onUploadProgress = (res) => {
        if (timer !== null) clearTimeout(timer);

        let timestamp = new Date().valueOf();
        let duration = timestamp - oldTime; //时间间隔（毫秒）
        let bitrate = 0;
        let botrateText = "";

        if (duration > 0) {
          let size = sSize + res.loaded - oldLoadSize;
          bitrate = (size / duration / 1024) * 1000; // kbs
          if (bitrate > 1000) {
            botrateText = Math.round(bitrate / 1000) + "Mbps";
          } else {
            botrateText = Math.round(bitrate) + "Kbps";
          }
        }
        oldTime = timestamp;
        oldLoadSize = sSize + res.loaded;

        timer = setTimeout(function () {
          setVideoList((prevCount: any) => {
            const newCount = [...prevCount];
            newCount[index].timeremain = calcUpdateTime(
              file.size - oldLoadSize,
              bitrate
            );
            newCount[index].bitrate = botrateText;
            newCount[index].progress = calcProgress(oldLoadSize, file.size);

            return newCount;
          });
        }, 100);
      };

      axiosOptions.cancelToken = new axios.CancelToken(function executor(c) {
        setVideoList((prevCount: any) => {
          let newCount = [...prevCount];
          newCount[index].cancel = c;
          return newCount;
        });
      });

      await axios(axiosOptions)
        .then((res) => {
          result = res.data.result;
          sSize = res.data.received;
          eSize =
            sSize + SECTIONSIZE > file.size
              ? file.size - 1
              : sSize + SECTIONSIZE;

          if (result === 1) {
            saveVideo({
              fileName: file.name,
              fileSize: file.size,
              thirdVideoId: createUpload.videoId,
              subjectId: props.treeSelect,
            }).then((res: any) => {
              console.log("上传成功" + res);
              props.getList();
            });
          }

          if (result !== 0) {
            delete FILELIST[file.uid];

            setVideoList((prevCount: any) => {
              const newCount = [...prevCount];
              newCount[index].state = result;
              return newCount;
            });
          }
        })
        .catch((err) => {
          result = -1;
        });
    }
  };

  const beforeUpload = (file: RcFile, list: RcFile[]) => {
    if (list.length > 50) {
      message.error("单次最多上传50个视频");
      return false;
    }

    // 后缀获取
    const flieArr = file.name.split(".");
    const suffix = flieArr[flieArr.length - 1];
    const allowTypeArr = [
      "mp4",
      "mkv",
      "avi",
      "wmv",
      "wm",
      "asf",
      "asx",
      "rm",
      "rmvb",
      "ra",
      "ram",
      "mpg",
      "mpeg",
      "mpe",
      "vob",
      "dat",
      "mov",
      "3gp",
      "mp4v",
      "m4v",
      "flv",
      "f4v",
      "mts",
    ];
    const checkType = allowTypeArr.find((item) => item === suffix);
    if (!checkType) {
      message.error("请选择正确的视频格式");
      return false;
    }

    // if (Math.round(file.size / 1024 / 1024 * 100) / 100 > (1024 * 5)) {
    //     message.error('请选择5G以内的视频');
    //     return false;
    // }
  };

  const uploadHandle = async (option: any) => {
    const { file } = option;

    let createUpload: ICreateUploadProp | undefined;

    // 请求接口：获取上传视频的CC信息
    await uploadVideo({
      fileName: encodeURI(file.name),
      fileSize: file.size,
    }).then((res: any) => {
      createUpload = res.data;
    });

    if (createUpload !== undefined) {
      getCCMetaInfo(createUpload.metaUrl, {
        ccvid: createUpload.videoId,
        uid: createUpload.userId,
        filename: encodeURI(file.name),
        filesize: file.size,
        servicetype: createUpload.serviceType,
      }).then((res: any) => {
        // 当前上传文件存入栈中
        FILELIST[file.uid] = file;

        new Promise((resolve) => {
          setVideoList((prevCount: any) => {
            const newCount = {
              key: prevCount.length,
              name: file.name,
              format: file.type,
              size: calcFileSize(file.size),
              state: res.result,
              timeremain: "00:00:00",
              bitrate: "0Kbps",
              progress: calcProgress(res.received, file.size),
              cancel: null,
              suspend: 0,
              create: createUpload,
              fileId: file.uid,
            };
            resolve({
              file: file,
              createUpload: createUpload,
              index: prevCount.length,
              meta: res,
            });
            return [...prevCount, newCount];
          });
        }).then((res) => {
          setUpLoadLength(uploadLength + 1);
          postVideoChunk(res);
        });
      });
    }
  };

  const onCloseHandle = () => {
    const incomplete = videoList.some((item: any) => {
      return item.state === 0 && item.suspend !== 2;
    });

    if (!incomplete) {
      return props.setIsUploadVideoVisible(false);
    }

    Modal.confirm({
      title: "关闭确认",
      content: "取消之后未完成的视频上传进度无法恢复，您确定关闭吗？",
      okText: "确认",
      cancelText: "取消",
      onOk() {
        return new Promise((resolve, reject) => {
          videoList.forEach((item: any) => {
            item.cancel();
          });
          FILELIST = {};
          setVideoList([]);
          props.setIsUploadVideoVisible(false);
          resolve("");
        }).catch(() => console.log("Oops errors!"));
      },
    });
  };

  return (
    <Modal
      title="视频上传"
      visible={props.isUploadVideoVisible}
      width={1100}
      onCancel={() => {
        onCloseHandle();
      }}
      footer={false}
    >
      <div className="courseupload-video">
        <Row
          className="videoupdate_update"
          gutter={{ xs: 5, sm: 10, md: 20, lg: 30 }}
        >
          <Col>
            <Upload
              name="avatar"
              multiple={true}
              listType="picture-card"
              className="avatar-uploader"
              showUploadList={false}
              // disabled={updateLists.length > 9}
              beforeUpload={(file: RcFile, list: RcFile[]) => {
                beforeUpload(file, list);
              }}
              customRequest={(file: UploadRequestOption) => {
                uploadHandle(file);
              }}
            >
              <div>
                <i className="ai-to-top"></i>
                <div style={{ marginTop: 8 }}>Upload</div>
              </div>
            </Upload>
          </Col>
          <Col>
            <p>
              支持视频格式:
              mp4/mkv/avi/wmv/wm/asf/asx/rm/rmvb/ra/ram/mpg/mpeg/mpe/vob/dat/mov/3gp/mp4v/m4v/flv/f4v/mts
            </p>
            <p>视频大小不超过10G</p>
            <p className="courseupload-strong">推荐分辨率：1090 * 720</p>
            <p className="courseupload-strong">推荐码率：1000</p>
          </Col>
        </Row>
        <Table
          dataSource={videoList}
          columns={columns}
          pagination={false}
          rowKey={"key"}
        />
      </div>
    </Modal>
  );
};
